module.exports = __webpack_public_path__ + "img/8H.3043fb50.png";